import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { Map } from "ol";
import { EventsKey } from "ol/events";
import { unByKey } from "ol/Observable";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  readMapSettings,
  updateMapSettings,
} from "../../functions/localMapSettings";
import { CustomMapEventTypes } from "../../types/map";

interface Props {
  map?: Map;
}

export const AtonExtraSettings = ({ map }: Props): JSX.Element => {
  const { t } = useTranslation("aton-layer-settings");
  const [settingsChanged, setSettingsChanged] = React.useState(false);
  const [showAlertCircle, setShowAlertCircle] = React.useState(
    readMapSettings("atonAlertCircle"),
  );
  const [showOnlyFaulted, setShowOnlyFaulted] = React.useState(
    readMapSettings("atonOnlyFaulted"),
  );
  const [showOnlyRemote, setShowOnlyRemote] = React.useState(
    readMapSettings("atonOnlyRemote"),
  );

  React.useEffect(() => {
    let key: EventsKey | EventsKey[];
    if (map) {
      key = map.on(CustomMapEventTypes.SettingsChanged, () =>
        setSettingsChanged((prev) => !prev),
      );
    }
    return () => {
      unByKey(key);
    };
  }, [map]);

  React.useEffect(() => {
    setShowAlertCircle(readMapSettings("atonAlertCircle"));
    setShowOnlyFaulted(readMapSettings("atonOnlyFaulted"));
    setShowOnlyRemote(readMapSettings("atonOnlyRemote"));
  }, [settingsChanged]);

  const udpateMap = () => {
    map?.dispatchEvent(CustomMapEventTypes.SettingsChanged);
  };

  return (
    <>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              color="secondary"
              checked={showAlertCircle ?? false}
              onChange={(_e, v) => {
                updateMapSettings({ atonAlertCircle: v });
                udpateMap();
              }}
            />
          }
          label={t("alarm-circle")}
        />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              color="secondary"
              checked={showOnlyFaulted ?? false}
              onChange={(_e, v) => {
                updateMapSettings({ atonOnlyFaulted: v });
                udpateMap();
              }}
            />
          }
          label={t("only-faulted")}
        />
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              color="secondary"
              checked={showOnlyRemote ?? false}
              onChange={(_e, v) => {
                updateMapSettings({ atonOnlyRemote: v });
                udpateMap();
              }}
            />
          }
          label={t("only-remote")}
        />
      </Grid>
    </>
  );
};
